// TODO: remove calcHeight once iOS 13 adoption > 90%
// In iOS 13 and up we use visualViewport API to calculate height

// we can't tell what the actual visible window height is
// because we cannot account for the height of the mobile keyboard
// and any other mobile autocomplete UI that may appear
// so let's be conservative here rather than trying to max out every
// available pixel of height for the editor
export function calcIosHeight() {
    // estimate 270 px for keyboard
    let withoutKeyboard = window.innerHeight - 270;
    const min = 270;

    // iPhone shrinks header and removes footer controls ( back / forward nav )
    // at 39px we are at the largest viewport
    const portrait = window.innerHeight > window.innerWidth;
    const smallViewport = (portrait ? window.screen.height : window.screen.width) - window.innerHeight > 40;

    if (portrait) {
        // iPhone SE, it is super small so just
        // have a bit of crop
        if (window.screen.height === 568) {
            withoutKeyboard = 270;
        }

        // iPhone 6/7/8
        if (window.screen.height === 667) {
            withoutKeyboard = smallViewport ? 295 : 325;
        }

        // iPhone 6/7/8 plus
        if (window.screen.height === 736) {
            withoutKeyboard = smallViewport ? 353 : 383;
        }

        // iPhone X
        if (window.screen.height === 812) {
            withoutKeyboard = smallViewport ? 340 : 370;
        }

        // iPhone Xs Max and iPhone XÊ€
        if (window.screen.height === 896) {
            withoutKeyboard = smallViewport ? 410 : 440;
        }

        // iPad can use innerHeight cause it renders nothing in the footer
        if (window.innerHeight > 920) {
            withoutKeyboard -= 45;
        }
    } else {
        // landscape
        // iPad, we have a bigger keyboard
        if (window.innerHeight > 665) {
            withoutKeyboard -= 128;
        }
    }

    // iPad portrait also has a bigger keyboard
    return Math.max(withoutKeyboard, min);
}
